import { assoc, dissoc, mapObjIndexed, reduce, values } from "ramda";
import { SummedValue } from "../derivedModel/accountValues";
import { SpreadFinancialValueLens } from "../derivedModel/spreadFinancialValues";
import { AccountMap } from "../derivedModel/types";
import { AccountId, SpreadSheetType } from "../spread/types";
import { AccountPresenter } from "./types";

const hiddenPresenters = (
  accountId: AccountId,
  spreadSheetType: SpreadSheetType,
  summedValues: SummedValue[][],
  getAccountValuesById: (id: AccountId) => Array<number | undefined>,
  getLensesById: (id: AccountId) => SpreadFinancialValueLens[],
  userEditedStatesByPeriod: boolean[]
): AccountPresenter[] => {
  if (summedValues.length === 0) {
    return [];
  }

  const idToName = reduce(
    (outerAcc: AccountMap<AccountId>, summedValueList) =>
      reduce(
        (innerAcc, summedValue) =>
          assoc(
            summedValue.accountId,
            summedValue.spreadFinancialValue.asReportedLabel ||
              summedValue.spreadFinancialValue.name,
            innerAcc
          ),
        outerAcc,
        summedValueList
      ),
    {},
    summedValues
  );

  return values(
    mapObjIndexed(
      (name: string, id): AccountPresenter => ({
        id,
        name,
        type: "HIDDEN",
        children: [],
        periodValues: getAccountValuesById(id),
        valueLensesByPeriod: getLensesById(id),
        spreadSheetType,
        documentExceptions: [],
        userEditedByPeriod: userEditedStatesByPeriod,
        exceptionEligible: false,
        formula: ""
      }),
      dissoc(accountId, idToName)
    )
  );
};

export default hiddenPresenters;



// WEBPACK FOOTER //
// ./src/spread/model/presenter/hiddenPresenters.ts